import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { MerchantForm } from "@/components/merchants/merchant-form";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/merchants/create")({
  component: CreateMerchantPage,
});

function CreateMerchantPage() {
  return (
    <ProtectedRoute>
      <AppShell>
        <div className="max-w-4xl mx-auto space-y-6">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Create Merchant</h1>
            <p className="text-muted-foreground">
              Add a new merchant account to the platform
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Merchant Information</CardTitle>
              <CardDescription>
                Fill in the details below to create a new merchant account
              </CardDescription>
            </CardHeader>
            <CardContent>
              <MerchantForm />
            </CardContent>
          </Card>
        </div>
      </AppShell>
    </ProtectedRoute>
  );
}
